<template>
  <modal :visible.sync="isShowDialog" :title="$t('integration.select_point')"  width="500px" @close="close">
      <div class="treeClass">
          <StatisticObject
          ref="tree"
            v-if="treeData.length"
          :loadNow="true"
          :tree-data="treeData"
          hide-button
          class="ex-tree"
          :checked="carrierList.map(_ => _.carrier_id).join(',')"
        ></StatisticObject>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="close">{{ $t('public.btn_cancel') }}</el-button>
        <el-button type="primary" @click="handleSave">{{ $t('public.save') }}</el-button>
      </div>

    </modal>
</template>
<script>
import StatisticObject from '@/pages/count/statistic/component/StatisticObject/StatisticObject.vue'
import { shareTree } from '@/api/modules/public'
import { ruleSaveCarrier } from '@/api/modules/abnormal.js'

export default {
  name: 'CarrierDialog',
  components: { StatisticObject },
   props: {
    isShow: {
      type: Boolean,
      default: false
    },
    ruleId: {
      type: Number | String,
      default: ''
    },
    carrierList: {
      type: Array,
      default: () => {}
    }
  },
  data(){
    return {
      treeData: [],

    }
  },
  mounted() {
    this.getTree()
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
  },
  methods: {
    close(){
      this.isShowDialog = false
      this.$emit('close')
    },
    handleSave(){
      // 获取树形安装点选中的list
     let ids =  this.$refs.tree.getTreeConfirm()

     ruleSaveCarrier(this.ruleId, ids).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.success'))
          this.close()
          // 更新父页面中关联的监测点list
          this.$parent.updateCarrier()
        }
      })
    },
    getTree () {
      shareTree({
        isEdit: 0,
        carrier: true,
        all: true
      }).then(({ result }) => {
        this.treeData = (result && result.item) || []
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.treeClass {
  width: 300px;
  height: 500px;
  overflow: auto;

  .el-tree {
    height: 100%;
  }
}
.ex-tree {
  height: 350px;
  ::v-deep .tree {
    height: 100%;
  }
}

</style>
